import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import StandardTableVue from '../../../components/table/StandardTable.vue';
import Sortable from 'sortablejs';
import { lineParamsList, wxParamsList, qqParamsList, wbParamsList, fbParamsList } from './socialComponent/config';
import fromModel from './socialComponent/formMOdel.vue';
import notifySetting from './socialComponent/notifySetting.vue';
import { socialLoginIsopen, socialLoginNotifyIsopen, queryNotifyList, changeSocialLoginList, socialLoginData, editSocialLogin } from '@/services/systemsetting.js';
import { imgObj } from './socialComponent/imgConfig';
// const data = [
//   {
//     Number: 1,
//     key: '1',
//     thirdPlatforms: 'Line',
//     sendMsg:'开启',
//     state: 1,
//   },
//    {
//     Number: 2,
//        key: '2',
//     thirdPlatforms: '微信',
//     sendMsg:'关闭',
//     state: 1,
//   },
//   {
//     Number: 3,
//        key: '3',
//     thirdPlatforms: 'QQ',
//     sendMsg:'',
//     state: 1,
//   },
//   {
//     Number: 4,
//        key: '4',
//     thirdPlatforms: '新浪微博',
//     sendMsg:'',
//     state: 0,
//   },
//   {
//     Number: 5,
//        key: '5',
//     thirdPlatforms: 'FaceBook',
//     sendMsg:'',
//     state: 0,
//   },
// ];
export default {
  components: {
    StandardTableVue: StandardTableVue,
    fromModel: fromModel,
    notifySetting: notifySetting
  },
  i18n: require("./../i18n-basucSettings"),
  props: ["systemSetting"],
  data: function data() {
    var columns = [{
      dataIndex: 'showOrder',
      title: this.$t('emailNumber'),
      scopedSlots: {
        customRender: 'showOrder'
      }
    }, {
      title: this.$t('socialLogin.columns.thirdPlatforms'),
      dataIndex: 'platformName',
      width: '300px'
    }, {
      title: this.$t('emailState'),
      dataIndex: 'loginSwitch',
      scopedSlots: {
        customRender: 'loginSwitch'
      }
    }, {
      title: this.$t('socialLogin.columns.messageNotify'),
      dataIndex: 'nfOpen',
      scopedSlots: {
        customRender: 'nfOpen'
      }
    }, {
      title: this.$t('emailAction'),
      dataIndex: 'action',
      scopedSlots: {
        customRender: 'action'
      }
    }];
    // const checkToken =(rule, value, callback)  => {
    //     if(value !== '') {
    //       this.errorTip = false

    //     }
    //     return callback()

    // };
    var lineRules = {
      appId: [{
        required: true,
        message: this.$t('socialLogin.lineRule1'),
        trigger: 'blur'
      }],
      appSecret: [{
        required: true,
        message: this.$t('socialLogin.lineRule2'),
        trigger: 'blur'
      }]
      // nfToken: [{validator: checkToken, trigger: 'change' }]
    };

    // const wxRules = {
    //     appid: [{required: true, message: this.$t('socialLogin.wxRule1'), trigger: 'blur' }],
    //     Secret:[{required: true, message: this.$t('socialLogin.wxRule2'), trigger: 'blur' }],
    //     appid2: [{required: true, message: this.$t('socialLogin.wxRule1'), trigger: 'blur' }],
    //     Secret2:[{required: true, message: this.$t('socialLogin.wxRule2'), trigger: 'blur' }],
    //     appid3: [{required: true, message: this.$t('socialLogin.wxRule1'), trigger: 'blur' }],
    //     Secret3:[{required: true, message: this.$t('socialLogin.wxRule2'), trigger: 'blur' }],
    // }

    var qqRules = {
      appId: [{
        required: true,
        message: this.$t('socialLogin.wxRule1'),
        trigger: 'blur'
      }],
      appSecret: [{
        required: true,
        message: this.$t('socialLogin.wbRule1'),
        trigger: 'blur'
      }]
    };
    var wbRules = {
      appId: [{
        required: true,
        message: this.$t('socialLogin.wbRule1'),
        trigger: 'blur'
      }],
      appSecret: [{
        required: true,
        message: this.$t('socialLogin.wbRule2'),
        trigger: 'blur'
      }]
    };
    var fbRules = {
      appId: [{
        required: true,
        message: this.$t('socialLogin.wxRule1'),
        trigger: 'blur'
      }]
    };
    var columnsNotify = [{
      dataIndex: 'showOrder',
      title: this.$t('emailNumber'),
      scopedSlots: {
        customRender: 'showOrder'
      }
    }, {
      title: this.$t('emailNotify'),
      dataIndex: 'nfTypeName'
    }, {
      title: this.$t('emailState'),
      dataIndex: 'switchStatus',
      scopedSlots: {
        customRender: 'switchStatus'
      }
    }, {
      title: this.$t('emailAction'),
      dataIndex: 'action',
      scopedSlots: {
        customRender: 'action'
      },
      align: 'center'
    }];
    return {
      data: [],
      columns: columns,
      title: '',
      visible: false,
      form: {},
      formList: [],
      rules: {},
      lineParamsList: lineParamsList,
      lineRules: lineRules,
      settingTitle: '',
      settingVisible: false,
      width: '800px',
      formWidth: '600px',
      wxParamsList: wxParamsList,
      // wxRules,
      dialogStyle: {},
      qqParamsList: qqParamsList,
      qqRules: qqRules,
      wbParamsList: wbParamsList,
      wbRules: wbRules,
      fbParamsList: fbParamsList,
      fbRules: fbRules,
      errorTip: false,
      nfToken: '',
      rowid: '',
      nfWay: null,
      notiftOpen: null,
      notifyData: [],
      showHtml: false,
      html: '',
      columnsNotify: columnsNotify,
      tableLoading: false,
      imgObj: imgObj,
      notiType: ''
    };
  },
  mounted: function mounted() {
    this.initData();
    this.rowDrop();
  },
  watch: {
    form: {
      handler: function handler(obj) {
        if (obj.nfToken == '') {
          this.errorTip = true;
        } else {
          this.errorTip = false;
        }
      },
      deep: true
    }
  },
  methods: {
    rowDrop: function rowDrop() {
      var tbody = document.querySelector("#social .ant-table-tbody"); // 元素选择器名称根据实际内容替换
      var _this = this;
      Sortable.create(tbody, {
        onEnd: function onEnd(_ref) {
          return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
            var newIndex, oldIndex, currRow, params, res;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  newIndex = _ref.newIndex, oldIndex = _ref.oldIndex;
                  currRow = _this.data.splice(oldIndex, 1)[0];
                  _this.data.splice(newIndex, 0, currRow);
                  _this.data.forEach(function (item, index) {
                    item.showOrder = index + 1;
                  });
                  params = _this.data.map(function (item) {
                    return {
                      id: item.id,
                      showOrder: item.showOrder
                    };
                  }); // 更新数据接口 只有顺序改变了才会调用接口
                  if (!(newIndex !== oldIndex)) {
                    _context.n = 2;
                    break;
                  }
                  _context.n = 1;
                  return changeSocialLoginList(params);
                case 1:
                  res = _context.v;
                  if (res.data.code == 200) {
                    _this.$message.success(_this.$t('public.updateSuccessfully'));
                  }
                case 2:
                  return _context.a(2);
              }
            }, _callee);
          }))();
        }
      });
    },
    initData: function initData() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this2.tableLoading = true;
              _context2.p = 1;
              _context2.n = 2;
              return socialLoginData();
            case 2:
              res = _context2.v;
              if (res.data.code == 200) {
                _this2.data = res.data.data;
              }
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
            case 4:
              _context2.p = 4;
              _this2.tableLoading = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, null, [[1, 3, 4, 5]]);
      }))();
    },
    clickNotice: function clickNotice(row) {
      this.rowid = row.id;
      this.settingTitle = row.platformName;
      // this.notiftOpen = row.nfOpen
      if (row.platformType == 4) {
        this.nfWay = 2;
        this.notiType = 'special';
      } else if (row.platformType == 0) {
        this.notiType = '';
        this.nfWay = 1;
      }
      this.initNotify();
    },
    initNotify: function initNotify() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return queryNotifyList(_this3.nfWay);
            case 1:
              res = _context3.v;
              if (res.data.code == 200) {
                _this3.notifyData = res.data.data;
                _this3.settingVisible = true;
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    edit: function edit(row) {
      // if(!row.configInfolist[0].nfToken) {
      //   this.errorTip = true
      // } else {
      //   this.errorTip = false
      // }
      this.rowid = row.id;
      this.dialogStyle = {};
      this.formList = [];
      this.visible = true;
      this.title = row.platformName;
      console.log(row);
      if (row.platformType == 4) {
        this.form = {
          appId: row.configInfolist[0].appId,
          appSecret: row.configInfolist[0].appSecret,
          url: row.mobileCallBackUrl ? row.pcCallBackUrl ? row.mobileCallBackUrl + '\n' + row.pcCallBackUrl : row.mobileCallBackUrl : row.pcCallBackUrl,
          nfToken: row.configInfolist[0].nfToken
        };
        // if(row.configInfolist[0].nfToken) {
        //   this.nfToken = row.configInfolist[0].nfToken
        // } else {
        //   this.nfToken = ''
        // }
        //这里需要接口返回一个多语言的title
        this.formList = this.lineParamsList;
        this.rules = this.lineRules;
      } else if (row.platformType == 0) {
        this.dialogStyle = {
          top: '30px'
        };
        this.form = {
          appid: row.configInfolist[0].appId,
          Secret: row.configInfolist[0].appSecret,
          appid2: row.configInfolist[1].appId,
          Secret2: row.configInfolist[1].appSecret,
          appid3: row.configInfolist[2].appId,
          Secret3: row.configInfolist[2].appSecret,
          appid4: row.configInfolist[3].appId,
          Secret4: row.configInfolist[3].appSecret
        }, this.formList = this.wxParamsList;
        this.rules = {};
      } else if (row.platformType == 1) {
        this.dialogStyle = {
          top: '200px'
        };
        this.form = {
          appId: row.configInfolist[0].appId,
          appSecret: row.configInfolist[0].appSecret,
          url: row.mobileCallBackUrl ? row.mobileCallBackUrl + ';' + row.pcCallBackUrl : row.pcCallBackUrl + ';' + row.mobileCallBackUrl
        }, this.formList = this.qqParamsList;
        this.rules = this.qqRules;
      } else if (row.platformType == 2) {
        this.dialogStyle = {
          top: '200px'
        };
        this.form = {
          appId: row.configInfolist[0].appId,
          appSecret: row.configInfolist[0].appSecret
        }, this.formList = this.wbParamsList;
        this.rules = this.wbRules;
      } else if (row.platformType == 3) {
        this.dialogStyle = {
          top: '200px'
        };
        this.form = {
          appId: row.configInfolist[0].appId
        }, this.formList = this.fbParamsList;
        this.rules = this.fbRules;
      }
    },
    // 编辑弹窗确定
    ok: function ok(e) {
      var _this4 = this;
      e.validate(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(valid) {
          var len, params, res;
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.n) {
              case 0:
                if (!valid) {
                  _context4.n = 2;
                  break;
                }
                len = Object.keys(_this4.form).length;
                if (len > 6) {
                  params = [{
                    appId: _this4.form.appid,
                    appSecret: _this4.form.Secret,
                    nfToken: ''
                  }, {
                    appId: _this4.form.appid2,
                    appSecret: _this4.form.Secret2,
                    nfToken: ''
                  }, {
                    appId: _this4.form.appid3,
                    appSecret: _this4.form.Secret3,
                    nfToken: ''
                  }, {
                    appId: _this4.form.appid4,
                    appSecret: _this4.form.Secret4,
                    nfToken: ''
                  }];
                } else {
                  params = [{
                    appId: _this4.form.appId ? _this4.form.appId : '',
                    appSecret: _this4.form.appSecret ? _this4.form.appSecret : '',
                    nfToken: _this4.form.nfToken ? _this4.form.nfToken : ''
                  }];
                }
                _context4.n = 1;
                return editSocialLogin(_this4.rowid, params);
              case 1:
                res = _context4.v;
                if (res.data.code == 200) {
                  _this4.$message.success(_this4.$t('public.updateSuccessfully'));
                  _this4.visible = false;
                  _this4.initData();
                  // e.resetFields()
                }
              case 2:
                return _context4.a(2);
            }
          }, _callee4);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    // 编辑弹窗取消
    cancel2: function cancel2(e) {
      this.visible = false;
      e.resetFields();
    },
    // 启用禁用确定
    confirm: function confirm(row) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return socialLoginIsopen(row.id, 1 - row.loginSwitch);
            case 1:
              res = _context5.v;
              if (res.data.code == 200) {
                _this5.$message.success(_this5.$t('public.updateSuccessfully'));
                _this5.initData();
              }
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    // 启用禁用取消
    cancel: function cancel() {
      // this.$message.error(this.$t('switchError'));
    },
    SettingOk: function SettingOk(obj) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var params, res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              params = {
                id: obj.id,
                status: 1 - obj.switchStatus
                // nfTyp:,  邮件通知类型
              };
              _context6.n = 1;
              return socialLoginNotifyIsopen(params);
            case 1:
              res = _context6.v;
              if (res.data.code == 200) {
                _this6.$message.success(_this6.$t('public.updateSuccessfully'));
                _this6.initNotify();
              }
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    //  通知设置取消
    settingCancel: function settingCancel() {
      this.initData();
      this.settingVisible = false;
    },
    //  通知预览
    notifyPreview: function notifyPreview(row) {
      this.html = this.imgObj[this.rowid][Number(row.nfType) - 1] ? this.imgObj[this.rowid][Number(row.nfType) - 1] : '';
      console.log(this.html);
      //  this.html = this.imgObj['0'][1]
      if (this.html == '') {
        this.$message.warning(this.$t('public.noPreview'));
      } else {
        console.log(1111);
        this.showHtml = true;
      }
    } //  changeNotiftOpen(val) {
    //   this.notiftOpen = val
    //   },
  }
  // 通知预览关闭
};